import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetPaymentRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetPaymentResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getPayment = (request: GetPaymentRequest, options?: CashRequestOptions) =>
  post<GetPaymentRequest, GetPaymentResponse>('/2.0/cash/get-payment', request, { ...options, rejectOnError: true })
